export enum SaveResult {
    Success,
    Error,
    FormErrors,
    /** Failed, and the reason has already been shown — the caller must not report it again. */
    ErrorReported,
}
